import type { Pixel } from '@/data';
import type { ImageDimensions } from '@/data/sources/Source';

/**
 * This function is here and not in sources.ts just because of tests
 *
 * see : _mock one function using jest.mock() and not another in the same file_ https://stackoverflow.com/a/72612857/10967760
 */
export async function loadImageDimensions(url: string): Promise<ImageDimensions> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve({
      width: image.naturalWidth as Pixel,
      height: image.naturalHeight as Pixel,
    });
    image.onerror = reject;
    image.src = url;
  });
}
